import {DateTime} from 'luxon'
import moment from 'moment'

import i18n from '@/i18n'
import {SalesAppointmentLogItem} from '@/mappers/comments'
import {SalesAppointmentResponse} from '@/types/sales-appointments'
import {getDealerTimezone} from '@/utils/timezone'

export function mapSalesAppointmentsToCommentItems(
  appointments: SalesAppointmentResponse[],
): SalesAppointmentLogItem[] {
  const timezone = getDealerTimezone(i18n.locale)

  return appointments.map(appointment => {
    const start = DateTime.fromISO(appointment.startDate, {zone: timezone})
    const end = appointment.endDate ? DateTime.fromISO(appointment.endDate, {zone: timezone}) : null
    const typeKey = `leads.detail.sales-appointments.type.${appointment.appointmentType}`
    const typeLabel = i18n.te(typeKey) ? i18n.t(typeKey) : i18n.t('leads.detail.sales-appointments.title')

    let text: string
    if (end && end > start) {
      text = `${typeLabel} ${start.toFormat('dd/MM/yyyy')} → ${start.toFormat('HH:mm')}-${end.toFormat('HH:mm')}`
    } else {
      const timeAt = i18n.t('leads.detail.sales-appointments.time-at')
      text = `${typeLabel} ${start.toFormat('dd/MM/yyyy')} ${timeAt} ${start.toFormat('HH:mm')}`
    }

    return {
      text,
      dueDate: appointment.startDate,
      timestamp: moment(appointment.createdAt || appointment.startDate),
      isRemovable: false,
      appointmentId: appointment.id,
      appointmentType: appointment.appointmentType,
      appointmentStatus: appointment.status,
      appointmentComment: appointment.comment,
    }
  })
}
